import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-053c353a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "/",
  class: "footer w-100 d-flex justify-content-between align-items-center mt-4 blog-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs-5 text-center" }, "© Eric Tarter")
], -1))

import Socials from './utilities/Socials.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BlogFooter',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(Socials)
  ]))
}
}

})